var voted_users_rtlignore_default = {
  "container": "_96YsK",
  "webview": "pMTDZ",
  "avatar_list": "g--6p",
  "avatar": "vS6Qp",
  "user_avatar": "PBgCL",
  "modal": "O8fQq",
  "voted_users_modal": "nESVF",
  "overlay": "yPT6u",
  "user_card": "d1cMX",
  "user_name": "ktX9R",
  "voted_users_modal_header": "_9Zy3U",
  "cta": "LEgEd",
  "close_icon": "GNYL0",
  "title": "P8z6F",
  "member_list_container": "_6fHs8",
  "member_list": "XOJvW",
  "loader": "hlmL9",
  "anonymous_counter": "tJ1Sx",
  "spinner": "vYAdj",
  "spin": "dlcVf"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
